module.exports = __webpack_public_path__ + "img/bz.af88bc82.svg";